// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:06+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            83e7d4f678b4bec22d5d717ac5162d4c
//    Signature:      eyJpdiI6InJPbWUrUld5Q1wvcHhKWG55amZNOWxnPT0iLCJ2YWx1ZSI6ImZsM1wvZVwvZjBCRFBmVVY2WlVCdkJqM2FYcDNCbWNvV3gxN1VmbWE4UmY0QnZKNTd3ZHJzS1pISE4rNHRMMGFXTlJiZ3FjbW9Jb3VDeEcrSHV6MXhHWHE0SVNYeGduWUN6b3B1Nzk0b2JFKzk3Q0dibitoNlNiSzEzeHFRU2ZaNTFMalA4V2orZGlsNDNZTjdQY2l4cDlYRGZUTTNrMFBBcitBUGlBZ0t6czRvbDErVVJwOENDeW1pMGhuRW5sNDhLaUhXeE9mOWhuQTZKbVFnaUttcWJcL1JjVTIrZWpQYTMyNjNka3F2TjlKMlE5U0t6cEJPeE5jUUxidjFLK3lwdjE0VVdQOHN4bmIxUTIxbUdKZDRcL2xoSXN1NEZCVkc3SnpZMm9oWkV1YkhMSEtYblkwSHFFWFBcL0xsRWJaXC9VTXRwK1FTUXRFYTFcL2ZuMzZGMElhMndEb2lLejVqUlR6bE0yWGpxZ3dIVWlqZDBcL2plVDk1RHpWeWZpMDlJZ2hJc0krREZ6bFNaRTA1dVFBd3pXcWVxNVR3UT09IiwibWFjIjoiMGE0YjZlMzNmYjBjMjJjYTIyYmFhZWRjZjIyYzEzYWQ1Mzg5MTdkOGNmMjY4MDM3MTFjZWQ2MzdkMWI4YzlmNSJ9
class SizeGuideController extends HTMLElement {
  connectedCallback() {
    // Check if this is inside a modal or standalone
    const modal = this.closest('.product-popup-modal');
    const isModal = !!modal;
    
    if (isModal && modal.dataset.sizeGuideSetup === '1') return;

    const content = modal ? modal.querySelector('.product-popup-modal__content-info') : this.parentElement;
    if (!content) return;

    const sizingContainers = content.querySelectorAll('.Container.sizing');
    if (!sizingContainers.length) return;

    // Attach gender/unit interactions for each sizing container
    sizingContainers.forEach(container => {
      this.attachInteractions(container);
    });

    if (isModal) {
      modal.dataset.sizeGuideSetup = '1';
    }
  }

  attachInteractions(container) {
    const womenTab = container.querySelector('.clear-this .half[data-id="women-tab"]');
    const menTab = container.querySelector('.clear-this .half[data-id="men-tab"]');
    const womenSection = container.querySelector('.women');
    const menSection = container.querySelector('.men');

    // Toggle visble gender sections and active tab state
    const showGender = target => {
      if (!womenSection || !menSection) return;
      const showWomen = target === 'women';

      womenSection.style.display = showWomen ? '' : 'none';
      menSection.style.display = showWomen ? 'none' : '';

      if (womenTab) womenTab.classList.toggle('active', showWomen);
      if (menTab) menTab.classList.toggle('active', !showWomen);
  
    };

    // Switch the active unit (CM/INCH) within the current gender
    const activateUnit = (sectionRoot, unitId) => {
      if (!sectionRoot) return;

      const unitTabs = sectionRoot.querySelectorAll('.measurements');
      const unitPanels = sectionRoot.querySelectorAll('.measurement-contents');

      unitTabs.forEach(tab => tab.classList.remove('active'));
      unitPanels.forEach(panel => {
        panel.classList.remove('active');
        panel.style.display = 'none';
      });

      const targetTab = sectionRoot.querySelector(`.measurements[data-id="${unitId}"]`);
      const targetPanel = sectionRoot.querySelector(`.measurement-contents[data-id="${unitId}"]`);

      if (targetTab) targetTab.classList.add('active');
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.style.display = '';
      }
    };

    // Bind gender tab clicks (Women/Men)
    container.querySelectorAll('.clear-this .half').forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-id');
        if (id === 'women-tab') {
          showGender('women');
          activateUnit(womenSection, 'women-cm');
        } else if (id === 'men-tab') {
          showGender('men');
          activateUnit(menSection, 'men-cm');
        }
      });
    });

    [womenSection, menSection].forEach(sectionRoot => {
      if (!sectionRoot) return;
      sectionRoot.querySelectorAll('.measurements').forEach(button => {
        button.addEventListener('click', () => {
          const unitId = button.getAttribute('data-id');
          activateUnit(sectionRoot, unitId);
        });
      });
    });

    container.querySelectorAll('.measurement-contents').forEach(panel => {
      const shouldShow = panel.classList.contains('active');
      panel.style.display = shouldShow ? '' : 'none';
    });

    if (menSection && menTab && !menTab.classList.contains('active')) {
      menSection.style.display = 'none';
    }
  }
}

customElements.define('size-guide-controller', SizeGuideController);

// Watch for the product modal opening, then inject the controller
const observer = new MutationObserver(muts => {
  muts.forEach(m => {
    if (m.type === 'attributes' && m.attributeName === 'open' && m.target.classList && m.target.classList.contains('product-popup-modal')) {
      if (m.target.hasAttribute('open')) {
        const content = m.target.querySelector('.product-popup-modal__content-info');
        if (!content) return;

        const dataGender = m.target.getAttribute('data-gender');
        const genderTabs = m.target.querySelectorAll('.clear-this .half');
        for (const tab of genderTabs) {
          tab.classList.remove('active');
        }
        const activegender = m.target.querySelector(`.clear-this .half[data-id=${dataGender}-tab]`);
        activegender.click();

        if (!content.querySelector('size-guide-controller')) {
          const el = document.createElement('size-guide-controller');
          content.appendChild(el);
        }
      }
    }
  });
});

// Function to initialize size guides
function initializeSizeGuides() {
  // Initialize modal-based size guides
  document.querySelectorAll('.product-popup-modal').forEach(modal => {
    observer.observe(modal, { attributes: true });
  });
  
  // Initialize standalone size guides
  document.querySelectorAll('.Container.sizing').forEach(container => {
    if (!container.querySelector('size-guide-controller')) {
      const el = document.createElement('size-guide-controller');
      container.appendChild(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeSizeGuides);


